import { useState, useEffect } from 'react';

/**
 * Custom hook for managing active project and version context
 * Syncs with localStorage and global events
 */
export function useActiveProject() {
    // Global active context from localStorage
    const [activeProjectId, setActiveProjectId] = useState(
        localStorage.getItem('activeProjectId') || ''
    );
    const [activeProjectName, setActiveProjectName] = useState(
        localStorage.getItem('activeProjectName') || ''
    );
    const [activeVersionId, setActiveVersionId] = useState(
        localStorage.getItem('activeVersionId') || '00000000-0000-0000-0000-000000000000'
    );

    const isProduction = activeVersionId === '00000000-0000-0000-0000-000000000000';

    // Sync with global project change events
    useEffect(() => {
        const handleGlobalProjectChange = () => {
            const nextProjId = localStorage.getItem('activeProjectId') || '';
            setActiveProjectId(nextProjId);
            setActiveProjectName(localStorage.getItem('activeProjectName') || '');
        };
        window.addEventListener('activeProjectChanged', handleGlobalProjectChange);
        return () => window.removeEventListener('activeProjectChanged', handleGlobalProjectChange);
    }, []);

    // Sync with global version change events
    useEffect(() => {
        const handleGlobalVersionChange = () => {
            const nextVersionId = localStorage.getItem('activeVersionId') || '00000000-0000-0000-0000-000000000000';
            setActiveVersionId(nextVersionId);
        };
        window.addEventListener('activeVersionChanged', handleGlobalVersionChange);
        return () => window.removeEventListener('activeVersionChanged', handleGlobalVersionChange);
    }, []);

    return {
        activeProjectId,
        activeProjectName,
        activeVersionId,
        isProduction,
        setActiveProjectId,
        setActiveProjectName,
        setActiveVersionId
    };
}
